import * as React from "react";
import { ReportStep, StepStatus, StepType } from "./ReportTroubleshoot";
import { dateWithOptionalTime } from "../commons/utils/date";

interface StepProps {
  step: ReportStep;
}

export default class Step extends React.Component<StepProps> {
  render() {
    const { type, status, completionDate } = this.props.step;
    const detailI18n = getI18nDetail(status, type);

    return (
      <div
        className={
          "step h-flex align-center space-between" +
          (status === StepStatus.NOT_STARTED ? " disabled" : "")
        }
      >
        <div>
          <div>{i18n[getI18nTitle(type)]}</div>
          {detailI18n && (
            <div className={"detail" + (status === StepStatus.IN_PROGRESS ? " active" : "")}>
              {i18n[detailI18n]} {completionDate && dateWithOptionalTime(completionDate)}
            </div>
          )}
        </div>
        {this.props.step.status !== StepStatus.NOT_STARTED && (
          <div className={`h-flex centered icon ${getIconClasses(this.props.step)}`} />
        )}
      </div>
    );
  }
}

const getIconClasses = (step: ReportStep) => {
  switch (step.status) {
    case StepStatus.NOT_STARTED:
      return "";
    case StepStatus.SUCCESS:
      return "valid ic_check";
    case StepStatus.IN_PROGRESS:
      switch (step.type) {
        case StepType.UPLOADING:
          return "warning ic_upload";
        case StepType.ANALYSING:
          return "warning ic_analysing";
        default:
          return "";
      }
    case StepStatus.ERROR:
      return "danger ic_exclamation";
  }
};

const getI18nTitle = (stepType: StepType) => {
  switch (stepType) {
    case StepType.CREATION:
      return "Page.Reports.Troubleshoot.Step.Creation";
    case StepType.UPLOADING:
      return "Page.Reports.Troubleshoot.Step.Upload";
    case StepType.ANALYSING:
      return "Page.Reports.Troubleshoot.Step.Analysing";
  }
};

const getI18nDetail = (stepStatus: StepStatus, stepType: StepType) => {
  switch (stepStatus) {
    case StepStatus.IN_PROGRESS:
      return getI18nInProgress(stepType);
    case StepStatus.SUCCESS:
      return getI18nSuccess(stepType);
    case StepStatus.ERROR:
      return getI18nError(stepType);
  }
};

const getI18nInProgress = (stepType: StepType) => {
  switch (stepType) {
    case StepType.UPLOADING:
      return "Page.Reports.Troubleshoot.Step.Upload.InProgress";
    case StepType.ANALYSING:
      return "Page.Reports.Troubleshoot.Step.Analysing.InProgress";
  }
};

const getI18nError = (stepType: StepType) => {
  switch (stepType) {
    case StepType.UPLOADING:
      return "Page.Reports.Troubleshoot.Step.Upload.Error";
    case StepType.ANALYSING:
      return "Page.Reports.Troubleshoot.Step.Analysing.Error";
  }
};

const getI18nSuccess = (stepType: StepType) => {
  switch (stepType) {
    case StepType.CREATION:
      return "Page.Reports.Troubleshoot.Step.Creation.Success";
    case StepType.UPLOADING:
      return "Page.Reports.Troubleshoot.Step.Upload.Success";
    case StepType.ANALYSING:
      return "Page.Reports.Troubleshoot.Step.Analysing.Success";
  }
};
